export const SVR_STATUS_LABELS: Record<string, string> = {
  scheduled: "Scheduled",
  pending_review: "Pending PIC Review",
  closed: "Closed",
  report_sent: "Closed (Report Sent)",
  waived: "Waived",
};

export const JOB_STATUS_LABELS: Record<string, string> = {
  received: "Received",
  diagnosis: "Diagnosis",
  pending_finance: "Pending Finance",
  awaiting_commercial_review: "Awaiting Commercial Review",
  ready_to_send_to_customer: "Ready to Send to Customer",
  awaiting_customer_confirmation: "Awaiting Customer Confirmation",
  customer_declined: "Customer Declined",
  in_progress: "Repair Approved / In Progress",
  pending_parts: "Awaiting Parts",
  repair_complete: "Repair Complete",
  awaiting_payment: "Awaiting Payment",
  awaiting_collection: "Awaiting Collection",
  closed: "Closed",
};

export const JOB_STATUS_DESCRIPTIONS: Record<string, string> = {
  received: "Job logged, awaiting technician assignment",
  diagnosis: "Technician is assessing the fault",
  pending_finance: "Awaiting Finance to enter parts cost",
  awaiting_commercial_review: "Awaiting Admin/Finance to confirm the customer selling price",
  ready_to_send_to_customer: "Proposal ready — PIC must send to the customer",
  awaiting_customer_confirmation: "Awaiting customer approval before repair begins",
  customer_declined: "Customer has declined the repair — PIC follow-up required",
  in_progress: "Repair approved — technician may proceed",
  pending_parts: "Waiting for spare parts to arrive",
  repair_complete: "Repair done, ready for invoicing",
  awaiting_payment: "Invoice sent, awaiting customer payment",
  awaiting_collection: "Payment received, awaiting customer pickup or delivery",
  closed: "Collected, job fully complete",
};

export const JOB_STATUS_ORDER = [
  "received",
  "diagnosis",
  "pending_finance",
  "awaiting_commercial_review",
  "ready_to_send_to_customer",
  "awaiting_customer_confirmation",
  "customer_declined",
  "in_progress",
  "pending_parts",
  "repair_complete",
  "awaiting_payment",
  "awaiting_collection",
  "closed",
];

export const ROLE_LABELS: Record<string, string> = {
  admin: "Admin",
  service: "Service Team",
  finance: "Finance Team",
  sales: "Sales",
};

export const PRODUCT_CATEGORIES = [
  "Amplifier",
  "CD Player",
  "DAC",
  "Network Streamer",
  "Preamplifier",
  "Power Amplifier",
  "Integrated Amplifier",
  "Phono Stage",
  "Turntable",
  "Cartridge",
  "Loudspeaker",
  "Subwoofer",
  "Headphone Amplifier",
  "Headphones",
  "Cables & Accessories",
  "Other",
] as const;

export type ProductCategory = (typeof PRODUCT_CATEGORIES)[number];

export const CLARITY_LOGO_URL =
  "https://d2xsxph8kpxj0f.cloudfront.net/310519663414100320/brqZLwPGMDsYTB8zGXzCpe/ClarityLogo_b04fbabf.png";
